import useDialogStore from "@store/useDialogStore";
import { BaseDialog } from "@ui/Dialogs";

interface IConfirmChangePrimaryModalProps {
  onCancel?: () => void;
  onConfirm: () => void;
}

export function ConfirmChangePrimaryModal({
  onCancel,
  onConfirm,
}: IConfirmChangePrimaryModalProps) {
  const { closeDialog } = useDialogStore();

  return (
    <BaseDialog
      title="Change primary domain?"
      titleClassName="text-base justify-center"
      showCloseButton={false}
      primaryButton={{
        label: "Change",
        callback: () => {
          onConfirm();
          closeDialog();
        },
      }}
      secondaryButton={{
        label: "Cancel",
        buttonTypeOverride: "CANCEL",
        callback: () => {
          onCancel?.();
          closeDialog();
        },
      }}
    >
      <p className="px-4 text-center text-sm text-gray-700 dark:text-invertedPrimary80">
        Changing the primary domain will re-enrich this company with data from the new domain.
        <br />
        <br />
        Fields that were manually edited won&apos;t change.
      </p>
    </BaseDialog>
  );
}
